/**
 * Decryption key used to decrypt API responses
 * These positions and characters are removed from the encrypted string
 */
const deCryptKey = [
  { key: 11, value: 'l' },
  { key: 8, value: 'o' },
  { key: 2, value: 'b' },
]

/**
 * Decrypts an encrypted JSON string from the API
 * The API adds specific characters at specific positions that need to be removed
 * before Base64 decoding
 *
 * @param encryptedJson - The encrypted JSON string from the API
 * @returns The decrypted JSON string
 */
export function decryptJson(encryptedJson: string): string {
  // Important: Modify the same string in each iteration like Angular does
  // Each removal shifts the positions for subsequent removals
  deCryptKey.forEach((element) => {
    encryptedJson =
      encryptedJson.slice(0, element.key - 1) + encryptedJson.slice(element.key)
  })

  return atob(encryptedJson)
}

/**
 * Decrypts and parses an encrypted JSON response from the API
 *
 * @param encryptedJson - The encrypted JSON string from the API
 * @returns The parsed JSON object
 */
export function decryptAndParseJson(encryptedJson: string): any {
  const decrypted = decryptJson(encryptedJson)
  return JSON.parse(decrypted)
}
